'use client'

import { PWAInstallElement } from '@khmyznikov/pwa-install'
import PWAInstall from '@khmyznikov/pwa-install/react-legacy'
import { useEffect, useRef, useState } from 'react'

import { usePWAStore } from '@/store'

const PWAInstaller = () => {
  const setInstallerRef = usePWAStore((state) => state.setInstallerRef)
  const setIsLoading = usePWAStore((state) => state.setIsLoading)
  const [showInstaller, setShowInstaller] = useState(false)
  const pwaInstallRef = useRef<PWAInstallElement>(null)

  useEffect(() => {
    setInstallerRef(pwaInstallRef)
  }, [pwaInstallRef, setInstallerRef])

  useEffect(() => {
    setIsLoading(true)
    const UA = navigator.userAgent
    const IOS = UA.match(/iPhone|iPad|iPod/)
    const standalone = window.matchMedia('(display-mode: standalone)').matches
    const INSTALLED = !!(standalone || (IOS && !UA.match(/Safari/)))
    setShowInstaller(!INSTALLED)
    setIsLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!showInstaller) return null

  return (
    <PWAInstall
      ref={pwaInstallRef}
      name="Moments"
      icon="icons/icon_x512.png"
      description={`Your personal time capsule`}
      manifest-url="/manifest.json"
      disableScreenshots={true}
      manualApple={true}
      manualChrome={true}
    />
  )
}

export default PWAInstaller
